/**
 * Maps UI feature groups ({ comfort: { abs: true }, ... }) to the flat map
 * expected by the API inside featuresByCategory[category].
 */
export function flattenVehicleFeaturesForApi(
  categorizedFeatures: unknown,
): Record<string, boolean> {
  const flat: Record<string, boolean> = {}
  if (!categorizedFeatures || typeof categorizedFeatures !== 'object') return flat
  Object.values(categorizedFeatures as Record<string, unknown>).forEach((group) => {
    if (!group || typeof group !== 'object' || Array.isArray(group)) return
    Object.entries(group as Record<string, unknown>).forEach(([key, value]) => {
      if (value === true) flat[key] = true
    })
  })
  return flat
}

/**
 * Backend contract: `featuresByCategory` must include only the active vehicle category (A/B/C/D).
 */
export function buildFeaturesByCategoryPayload(
  category: string,
  categorizedFeatures: unknown,
): Record<string, Record<string, boolean>> {
  const code = category || 'B'
  return { [code]: flattenVehicleFeaturesForApi(categorizedFeatures) }
}

/** Flat map of enabled feature keys for the vehicle category (GET vehicle detail). */
export function getFlatFeaturesFromVehicleResponse(vehicle: {
  basic?: { category?: string }
  featuresByCategory?: Record<string, Record<string, boolean | number | string> | null> | null
}): Record<string, boolean | number | string> {
  const cat = vehicle.basic?.category
  const block = cat && vehicle.featuresByCategory ? vehicle.featuresByCategory[cat] : undefined
  if (!block || typeof block !== 'object') return {}
  return { ...block }
}
